<template>
  <section>
    <div class="form-group">
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <label class="inbox-label required">{{
            t("application.title")
          }}</label>
          <v-select
            :options="titleOptions"
            v-model="title"
            :reduce="(option) => option.code"
            :searchable="false"
            name="title"
            :fieldValue="title"
            :fieldTitle="t('application.title', {}, 'zh')"
            fieldname="title"
            required
          />
        </div>
        <div class="col-xs-12 col-sm-6">
          <label class="inbox-label required">{{
            t("application.mobile")
          }}</label>
          <input
            :fieldTitle="t('application.contact_mobile', {}, 'zh')"
            id="mobile"
            fieldname="mobile"
            type="tel"
            class="form-control"
            name="mobile"
            fieldType="mobile"
            field-attrs="unique"
            maxlength="8"
            minlength="8"
            v-model="mobile"
            required
          />
        </div>
      </div>
      <div class="col-xs-12 col-sm-6"></div>
    </div>
  </section>
</template>
<script>
import commonFunc from "../../../../assets/js/commonHelper";

export default {
  name: "StepShort",
  components: {},
  data: function () {
    return {
      titleOptions: [],
      title: "",
      mobile: ""
    };
  },
  mounted() {
    this.titleOptions = [
      {
        label: this.t("application.title_mr"),
        code: this.t("application.title_mr", null, "zh"),
      },
      {
        label: this.t("application.title_ms"),
        code: this.t("application.title_ms", null, "zh"),
      },
      {
        label: this.t("application.title_mrs"),
        code: this.t("application.title_mrs", null, "zh"),
      },
      {
        label: this.t("application.title_dr"),
        code: this.t("application.title_dr", null, "zh"),
      },
    ];
  },
  methods: {
    validateForm: function () {
      if (this.mobile.length !== 8) {
        commonFunc.toast(this.t("common.invalid_phone"), "warning");
        $("#mobile").focus();
        return false;
      }
      return true;
    }
  },
};
</script>
